module.exports = __webpack_public_path__ + "static/img/guide01.02b7d53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c18/guide01.png
// module id = Kh9g
// module chunks = 1